/*
* <license header>
*/

import React from 'react'
import { Flex, Heading, Text, View } from '@adobe/react-spectrum'
import { Link } from 'react-router-dom'

export const AboutSection = () => (
  <View
    marginBottom="size-200"
    UNSAFE_style={{
      padding: '2rem',
      border: '1px solid var(--card-border)',
      borderRadius: '8px',
      backgroundColor: 'var(--gray-50)'
    }}
  >
    <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '1.25rem', fontSize: '1.25rem', fontWeight: 700 }}>
      About AppBuilder Factory
    </Heading>
    <Text
      UNSAFE_style={{
        color: 'var(--gray-700)',
        fontSize: '0.9375rem',
        lineHeight: 1.6,
        marginBottom: '1.25rem'
      }}
    >
      AppBuilder Factory is your AI-powered hub for creating, vibe coding, and managing App Builder applications on the Adobe Platform. We provide templates, AI assistants, and implementation guides to help you build better experiences with Adobe technology.
    </Text>
    <Flex gap="size-200" wrap justifyContent="center" alignItems="center" UNSAFE_style={{ marginTop: '1rem' }}>
      <Link to="/app-types" className="AboutSection-link">
        Browse App Types
      </Link>
      <Link to="/apps" className="AboutSection-link">
        View Applications
      </Link>
      <Link to="/ask-assistant" className="AboutSection-link">
        Ask Assistant
      </Link>
      <a
        href="https://developer.adobe.com/app-builder/"
        target="_blank"
        rel="noopener noreferrer"
        className="AboutSection-link"
      >
        Adobe App Builder Docs ↗
      </a>
    </Flex>
  </View>
)
